import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, ConvertToCharacterCaseTwo, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { CommonApiData } from '../CommonComponents/EnvConfig';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const ModalMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        modelID: '',
        modelCode: 'System Generated',
        modelName: '',
        manufactureCode: '',
        isActive: true
    });

    const getModelMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowModelMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        } if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async() => {
        setFormData({
            modelID: '',
            modelCode: 'System Generated',
            modelName: '',
            manufactureCode: '',
            isActive: true
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateModelMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditModelMaster`, { modelID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteModelMaster`, { modelID: id }, getModelMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getModelMasterData(value);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ModalMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ModalMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            modelCode: 'System Generated',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("modelName", "manufactureCode", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateModelMaster', ImportData, Data2, getModelMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    useEffect(() => {
        getModelMasterData()
        document.title = 'Model Master'
        inputrefs.current['txtModelName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Model Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtModelCode"
                                    type="text"
                                    label='Model Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtModelName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='System Generated'
                                    name='ModelCode'
                                    value={formData.modelCode}
                                    disabled
                                />
                                <InputBox
                                    id="txtModelName"
                                    type="text"
                                    label='Model Name'
                                    required={true}
                                    placeholder="Model Name"
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    maxLength='50'
                                    value={formData.modelName}
                                    onChange={(e) => setFormData({ ...formData, modelName: ConvertToCharacterCaseTwo(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                />
                                <AutoCompleteBoxNew
                                    id="txtManufacturer"
                                    placeholder="Manufacturer"
                                    label={'Manufacturer'}
                                    required={true}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                    contextKey={formData.manufactureCode}
                                    autocompleteType='GetManufacture'
                                    value={formData.manufactureCode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, manufactureCode: newInputValue })
                                        }
                                    }}
                                    maxLength='50'
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowModelMaster`, filterData, 'Model Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                    
                </div>
            </div>
            <Table
                handleDelete={handleDelete}
                handleEdit={handleEditData}
                loading={isLoading}
                PageName={'ModelMaster'}
                handleFilter={() => {
                    getModelMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default ModalMaster;